<template>
    <div style="max-height: 500px; overflow-y: auto">
        <Loader :loader="applyingFilter" />
        <div v-show="postsLoaded && !applyingFilter">
            <div v-for="(post, index) in feed" :key="index">
                <FeedPost @openModalCheckInEdit="openModalCheckInEdit" :post="post" class="mr-3" />
                <hr />
            </div>
            <button-loader
                id="button-loader"
                :size="'md'"
                :variant="'link'"
                :loader="loadingFeed"
                :disable="loadingFeed"
                block
                @click="getNextPageUserFeed()"
                v-show="!isLastPage || loadingFeed"
            >
                {{ $t('form.button.seeMore') }}
            </button-loader>
        </div>
        <b-alert show variant="info" v-if="emptyFeed && !loadingFeed">
            {{ $t('targets.informations.noFeedToDisplay') }}
        </b-alert>
    </div>
</template>

<script>
import ButtonLoader from '@/views/components/button-loader'
import FeedPost from '@/views/feed/Post'
import { mapGetters, mapActions, mapState } from 'vuex'
import Loader from '@/views/components/loader'

export default {
    name: 'Feed',
    props: {
        userID: {
            type: [Number, String],
            required: true,
        },
    },
    components: {
        FeedPost,
        ButtonLoader,
        Loader,
    },
    methods: {
        ...mapActions('feed', ['getUserFeed', 'getNextPageUserFeed']),
        openModalCheckInEdit(data) {
            const { userId, targetId, checkinId } = data
            this.$router.push({
                path: `/v2/profile/${userId}/goal/${targetId}/checkin/${checkinId}`,
            })
        },
    },
    computed: {
        ...mapState('feed', ['feed', 'loadingFeed', 'pagination']),
        ...mapGetters({
            periods: 'periods',
            applyingFilter: 'applyingFilter',
        }),
        isLastPage() {
            return this.pagination.current_page == this.pagination.last_page
        },
        postsLoaded() {
            return this.feed.length > 0
        },
        emptyFeed() {
            return this.pagination.total == null || this.pagination.total == 0
        },
    },
}
</script>
<style scoped>
#button-loader {
    text-decoration: none;
}
</style>
